import { Col, Form, Modal, Row } from 'react-bootstrap'
import { CustomButton } from '../../../../components/CustomButton'
import { CheckCircleFill, XCircleFill } from 'react-bootstrap-icons'
import { useCallback, useEffect, useState } from 'react'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'
import { CustomSpinner } from '../../../../components/CustomSpinner'
import MotivosService from '../../../../services/database/MotivosService'
import { Center } from '../../../../components/Center'

export function ModalMotivo({
  title,
  isOpen,
  onClose,
  onRequest,
  isRequestLoading,
  codigo,
}) {
  const [descricao, setDescricao] = useState('')

  const [isMotivoLoading, setIsMotivoLoading] = useState(false)

  const getByCodigo = useCallback(async (codigo) => {
    try {
      setIsMotivoLoading(true)

      const { descricao: descricaoData } =
        await MotivosService.getByCodigo(codigo)

      setDescricao(descricaoData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os dados do motivo!')
    } finally {
      setIsMotivoLoading(false)
    }
  }, [])

  useEffect(() => {
    if (codigo) {
      getByCodigo(codigo)
    }
  }, [codigo, getByCodigo])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          {isMotivoLoading ? (
            <Center>
              <CustomSpinner size={40} />

              <h3
                style={{
                  margin: 0,
                }}
              >
                Carregando...
              </h3>
            </Center>
          ) : (
            <Col>
              <Form.Label>Descricao</Form.Label>

              <Form.Control
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                onKeyDown={(e) => {
                  if (String(e.target.value).trim().length > 0) {
                    if (e.key === 'Enter') {
                      onRequest({ codigo, descricao })
                    }
                  }
                }}
              />
            </Col>
          )}
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Salvar"
          color="#229954"
          onClick={() => onRequest({ codigo, descricao })}
          isLoading={isRequestLoading}
          isDisabled={!descricao.trim() || isRequestLoading}
          isLoadingText="Salvando..."
        >
          <CheckCircleFill />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          color="#b03a2e"
          isDisabled={isRequestLoading}
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
